<template>
  <div class="vx-row jrb" oncontextmenu="return false">
    <left-preview-slider v-if="isShowComment" v-on:click="isOpenPreview = $event"></left-preview-slider>
    <Transition name="baikei-transition">
    <div class="vx-col md:w-1/3 mb-base" v-if="(jrb == 'jrb-01' && jusetsuNo == 1 && isOpenPreview && isShowComment)" >
      <vx-card :title="jrb" >
        <img src="@/assets/images/jusetsu/screen-edit/jrb/M007-11/JRB-01-1.jpg" width="100%" />
      </vx-card>
    </div>
    <div class="vx-col md:w-1/3 mb-base" v-if="jrb == 'jrb-01' && (jusetsuNo == 5 || jusetsuNo == 9 ) && isOpenPreview && isShowComment" >
      <vx-card :title="jrb" >
        <img src="@/assets/images/jusetsu/screen-edit/jrb/M007-11/JRB-01-2.jpg" width="100%" />
      </vx-card>
    </div>

    <div class="vx-col md:w-1/3 mb-base" v-if="jrb == 'jrb-02' && jusetsuNo == 2 && isOpenPreview && isShowComment" >
      <vx-card :title="jrb" >
        <img src="@/assets/images/jusetsu/screen-edit/jrb/M007-11/JRB-02-1.jpg" width="100%" />
      </vx-card>
    </div>
    <div class="vx-col md:w-1/3 mb-base" v-if="jrb == 'jrb-02' && (jusetsuNo == 6 || jusetsuNo == 15 || jusetsuNo == 10 || jusetsuNo == 14 || jusetsuNo == 13) && isOpenPreview && isShowComment" >
      <vx-card :title="jrb" >
        <img src="@/assets/images/jusetsu/screen-edit/jrb/M007-11/JRB-02-2.jpg" width="100%" />
      </vx-card>
    </div>

    <div class="vx-col md:w-1/3 mb-base" v-if="jrb == 'jrb-03' && isOpenPreview && isShowComment" >
      <vx-card :title="jrb" >
        <img src="@/assets/images/jusetsu/screen-edit/jrb/M007-11/M007-11_jrb-03.jpg" width="100%" />
      </vx-card>
    </div>
    <div class="vx-col md:w-1/3 mb-base" v-if="jrb == 'jrb-04' && isOpenPreview && isShowComment" >
      <vx-card :title="jrb" >
        <img src="@/assets/images/jusetsu/screen-edit/jrb/M007-11/M007-11_jrb-04.jpg" width="100%" />
      </vx-card>
    </div>
    </Transition>
    <div class="vx-col mr-7 select flex-grow-width-make" :class="[!isShowComment && !isOpenPreview ? 'w-full' : !isShowComment ? 'w-57' : 'w-65']">
      <vx-card class=" preview-edit-screen">
      <table :id="`${arrayCommentId[0]}`">
        <div class="w-full part-parent-name h-10 pt-3 pl-2">
          <label>3.損害賠償額の予定または違約金に関する事項（一般社団法人不動産流通経営協会標準契約書式の契約条項です。）</label>
        </div>
        <table>
          <tr>
            <td colspan="2">
              <vs-checkbox @input="lostFocus" v-model="iyakukin_setsumei_shasen_hiku" vs-name="iyakukin_setsumei_shasen_hiku"
                           @change="handleCheck('iyakukin_setsumei_shasen_hiku')">違約金の説明を斜線にする</vs-checkbox>
            </td>
          </tr>
          <tr>
            <td rowspan="3">違約金
            </td>
            <td>
              <radio-box
                v-model="iyakukin_sentaku"
                vs-name="iyakukin_sentaku"
                vs-value="0"
                @change="handleCheck('iyakukin_sentaku')"
                :disabled="iyakukin_setsumei_shasen_hiku === true"
                @input="lostFocus"
              >１.手付金の額</radio-box>
            </td>
          </tr>
          <tr>
            <td>
              <div class="flex">
                 <radio-box
                v-model="iyakukin_sentaku"
                vs-name="iyakukin_sentaku"
                vs-value="1"
                :disabled="iyakukin_setsumei_shasen_hiku"
                @change="handleCheck('iyakukin_sentaku')"
                @input="lostFocus"
              >２.売買代金の</radio-box>
              <div>
                <vs-input class="ml-6" 
                  :maxlength="handleMaxLength_percent(3, iyakukin_baibaidaikin_wariai)"
                  @blur="iyakukin_baibaidaikin_wariai=formatNumber(iyakukin_baibaidaikin_wariai), focusOut()" @focus="onFocus('iyakukin_baibaidaikin_wariai')"
                  @input="iyakukin_baibaidaikin_wariai = checkValue(iyakukin_baibaidaikin_wariai)"
                  v-model="iyakukin_baibaidaikin_wariai"
                  :disabled="
                    iyakukin_setsumei_shasen_hiku ||
                    iyakukin_sentaku !== '1'
                  "
                ></vs-input>
                <span class="ml-6 tooltip-custom" :class="addPadding('iyakukin_baibaidaikin_wariai')">{{showMaxlength(3, iyakukin_baibaidaikin_wariai, 'iyakukin_baibaidaikin_wariai', true)}}</span>
              </div>
               <span class="ml-6 m-auto">％相当額</span>
              </div>
            </td>
          </tr>
          <tr>
            <td>
            <div class="flex">
              <radio-box
                v-model="iyakukin_sentaku"
                vs-name="iyakukin_sentaku"
                vs-value="2"
                :disabled="iyakukin_setsumei_shasen_hiku"
                @change="handleCheck('iyakukin_sentaku')"
                @input="lostFocus"
              >３.その他</radio-box>
              <div>
                <vs-input class="ml-6"
                  :maxlength="handleMaxLength(12, iyakukin_sonohoka_kingaku)"
                  @blur="iyakukin_sonohoka_kingaku=formatIntegerAdvanced(iyakukin_sonohoka_kingaku, true, 12), focusOut()" @focus="onFocus('iyakukin_sonohoka_kingaku')"
                  v-model="iyakukin_sonohoka_kingaku"
                  :disabled="
                    iyakukin_setsumei_shasen_hiku ||
                    iyakukin_sentaku !== '2'
                  "
                ></vs-input>
                <span class="ml-6 tooltip-custom" :class="addPadding('iyakukin_sonohoka_kingaku')">{{showMaxlength(12, iyakukin_sonohoka_kingaku, 'iyakukin_sonohoka_kingaku', true)}}</span>
              </div>
              <span class="ml-6 m-auto">円</span>
            </div>
            <div v-if="!formValidation.iyakukin_sentaku.status" class="text-warning" >
              {{formValidation.iyakukin_sentaku.message_warnning}}
            </div>
            </td>
          </tr>
        </table>
        <table>
          <tr>
            <td style="border-bottom: none">
              1.売主、買主は、前記
              <label v-if="jrb == 'jrb-01' && (jusetsuNo == 5 || jusetsuNo == 9 )">「IIー2.(4)契約違反による解除」</label>
              <label v-if="(jrb == 'jrb-01' && jusetsuNo == 1 ) || (jrb == 'jrb-02' && (jusetsuNo == 6 || jusetsuNo == 15 || jusetsuNo == 10 || jusetsuNo == 14 ))  || jrb == 'jrb-03' || jrb == 'jrb-04'">「IIー2.(5)契約違反による解除」</label>
              <label v-if="jrb == 'jrb-02' && (jusetsuNo == 2 || jusetsuNo == 13)">「IIー2.(6)契約違反による解除」</label>
              により、売買契約を解除するとき、その相手方に対して、上記違約金の支払いを請求することができます。ただし、
              売買契約および社会通念に照らして相手方の責めに帰すことができない事由によるものであるときは、
              違約金の請求はできません。なお、違約金に関し、現に生じた損害額の多寡を問わず、相手方に違約金の増減の請求をすることができません。
            </td>
          </tr>
          <tr style="border-bottom: none">
            <td>
              <label>2 違約金の支払い、清算は次のとおりおこないます。
              </label><br />
              <label>
                ①売主が違約した場合、売主は、買主に対し、すみやかに受領済みの金員を無利息にて返還するとともに、違約金を支払います。
              </label><br />
              <label>
                ②買主が違約した場合、違約金が支払い済みの金員を上回るときは、買主は、売主に対し、すみやかにその差額を支払い、
                支払い済みの金員が違約金を上回るときは、売主は、買主に対し、受領済みの金員から違約金相当額を控除して、すみやかに残額を無利息にて返還します。
              </label>
            </td>
          </tr>
        </table>
      </table>
      </vx-card>

      <!-- Footer -->
      <footer-button @cancel="popupActiveCancelForm = true" @save="checkSave"></footer-button>
      <!-- Popup Save -->
      <vs-popup class="holamundo"
                title="保存"
                :active.sync="popupActiveSaveForm"
                :button-close-hidden="true">
        <p class="my-4 font-bold text-lg">
          {{messageWhenHanei}}
        </p>
        <div class="flex justify-end">
          <vs-button class="mr-8 btn-positive btn-yes" @click="handleSave">はい</vs-button>
          <vs-button class="btn-positive" color="positive" type="filled" text-color="#7367F0" @click="popupActiveSaveForm = false">いいえ</vs-button>
        </div>
      </vs-popup>
      <!-- Popup Cancel -->
      <vs-popup class="holamundo"
                title="キャンセル"
                :active.sync="popupActiveCancelForm"
                :button-close-hidden="true">
        <p class="my-4 font-bold text-lg">
          {{messageWhenCancel}}
        </p>
        <div class="flex justify-end">
          <vs-button class="mr-8 btn-positive btn-yes" @click="handleSaveCancel">はい</vs-button>
          <vs-button class="btn-positive" color="positive" type="filled" text-color="#7367F0" @click="popupActiveCancelForm = false">いいえ</vs-button>
        </div>
      </vs-popup>
    </div>
    <vx-card class="vx-col comment-frame" id="closeCommentSiderPattern" :class="isShowComment ? 'closeComment': 'showComment'">
      <Comment @showHightlightInPage="handleShowHightlightInPage" @commentData="getArrayHighlight" :pattern="getJrbParttern" :screenCode="screenCode='M007-11'"/>
    </vx-card>
  </div>
</template>
<script>
import _ from 'lodash'
import FooterButton from './components/FooterButton.vue'
import RadioBox from './components/RadioBox.vue'
import { SAVE_JRB_M007_11, SAVE_EDIT_MODE, SAVE_KEIYAKU } from '@/store/modules/keiyaku/actions'
import { MESSAGE } from '../constant/message_code'
import routeIfCodeNull from '@/mixins/routeIfCodeNull'
import utilitiesMethods from '@/mixins/utilitiesMethods'
import { SAVE_BPM } from '../store/modules/keiyaku/actions'
import LeftPreviewSlider from './components/LeftPreviewSlider.vue'
import Comment from './comment'
import highlighter from '../mixins/highlighter'
import { M007_11_jrbHighlight } from '../constant/highlight'

export default {
  name: 'jrb-1',
  mixins: [routeIfCodeNull, utilitiesMethods, highlighter],
  components: {
    FooterButton,
    RadioBox,
    LeftPreviewSlider,
    Comment
  },
  data() {
    return {
      arrayCommentId: [],
      arrayHighlightId: [],
      isShowComment: true,
      isOpenPreview: true,
      messageWhenCancel: MESSAGE.M1008,
      messageWhenHanei: MESSAGE.M1007,
      iyakukin_setsumei_shasen_hiku: false,
      iyakukin_sentaku: null,
      iyakukin_baibaidaikin_wariai: null,
      iyakukin_sonohoka_kingaku: null,

      //popup
      popupActiveCancelForm: null,
      popupActiveSaveForm: null,
      formValidation: {
        iyakukin_sentaku: {
          warning: () => {
            return !this.iyakukin_setsumei_shasen_hiku && !this.iyakukin_sentaku
          },
          message_warnning : MESSAGE.E8051,
          status: true
        }
        // iyakukin_setsumei_shasen_hiku: {
        //   warning: true,
        //   message_warnning : MESSAGE.E8051,
        //   status: true
        // }
      },
      checkValidate: false
    }
  },
  computed: {
    getStateShowComment() {
      return this.$store.getters.getStateShowComment
    },
    getLeftPreviewSliderStatus() {
      return this.$store.getters.getLeftPreviewSliderStatus
    },
    handleMaxLength_percent() {
      return function(num, variable) {
        if (variable !== null) {
          const inputNum = String(variable)
          const comma = inputNum.match(/,/g) ? inputNum.match(/,/g).length : 0
          let dot = inputNum.match(/\./g) ? inputNum.match(/\./g).length : 0
          dot = dot ? dot + 2 : 0
          return comma + dot + num
        }
        return num
      }
    },
    bpmData() {
      return _.cloneDeep(_.get(this.$store.getters.keiyaku, 'baikei.bpm', null))
    },
    shakuchimensekiSum() {
      return this.shakuchikenTochiInputs
        .map((item) => item.chiseki)
        .reduce((a, b) => +a + +b, 0)
    },
    tochi_gokeimensekiSum() {
      return this.tochiInputs
        .map((item) => item.chiseki)
        .reduce((a, b) => +a + +b, 0)
    },
    shikikentochi_mensekiSum() {
      return this.shikikenmokutekitochiInputs
        .map((item) => item.chiseki)
        .reduce((a, b) => +a + +b, 0)
    },
    teikishakuchi_mensekiSum() {
      return this.teikiShakuchikenTochiInputs
        .map((item) => item.chiseki)
        .reduce((a, b) => +a + +b, 0)
    },
    jrb() {
      return  _.get(this.$store.getters.pattern, 'jusetsu.jrb', null)
    },

    jrbii3Data() {
      return _.cloneDeep(_.get(this.$store.getters.keiyaku, 'jusetsu.jrb07_11', null))
    },

    jusetsuNo() {
      return _.cloneDeep(_.get(this.$store.getters.pattern, 'jusetsuNo', null))
    }
  },
  mounted() {
    this.getStyleForEditScreen()
    this.handleGetCommentId()
    this.isShowComment = this.getStateShowComment
    this.isOpenPreview = this.getLeftPreviewSliderStatus
    if (this.jrbii3Data) {
      const jrb = this.jrbii3Data
      this.iyakukin_setsumei_shasen_hiku = jrb.iyakukin_setsumei_shasen_hiku
      this.iyakukin_sentaku = jrb.iyakukin_sentaku
      this.iyakukin_baibaidaikin_wariai = jrb.iyakukin_baibaidaikin_wariai
      this.iyakukin_sonohoka_kingaku = jrb.iyakukin_sonohoka_kingaku
    }

    const editMode = _.get(this.$store.getters.editMode, 'jrb07_11', false)
    if (editMode) {
      this.validateWarning()
    }
  },
  watch: {
    '$store.getters.getStateShowComment' (val) {
      this.isShowComment = val
    },
    '$store.getters.getLeftPreviewSliderStatus' (val) {
      this.isOpenPreview = val
    }
  },
  methods: {
    checkValue(number) {
      this.checkedNumber = number.replace(/,/g, '')
      if(this.checkedNumber >= 1000) {
        return number.slice(0, 3)
      }
      return number
    },
    handleCheck(type) {
      switch (type) {
      case 'iyakukin_setsumei_shasen_hiku':
        if(this.iyakukin_setsumei_shasen_hiku) {
          this.iyakukin_sentaku = null
          this.iyakukin_baibaidaikin_wariai = null
          this.iyakukin_sonohoka_kingaku = null
        }
        break
      case 'iyakukin_sentaku':
        if(String(this.iyakukin_sentaku) !== '1') {
          this.iyakukin_baibaidaikin_wariai = null
        }
        if(String(this.iyakukin_sentaku) !== '2') {
          this.iyakukin_sonohoka_kingaku = null
        }
        break
      }
    },
    handleSaveCancel() {
      this.handleSaveCountLocal()
      this.popupActiveCancelForm = false
      setTimeout(() => {
        this.$router.push({name: 'jusetsu-m006-01'})
      }, 200)
    },
    handleSave() {
      const handle = () => {
        const jrb = {
          iyakukin_setsumei_shasen_hiku: this.iyakukin_setsumei_shasen_hiku,
          iyakukin_sentaku: this.iyakukin_sentaku,
          iyakukin_baibaidaikin_wariai: this.iyakukin_baibaidaikin_wariai,
          iyakukin_sonohoka_kingaku: this.iyakukin_sonohoka_kingaku
        }
        const bpm = {
          iyakukingaku_sentaku: this.iyakukin_sentaku,
          iyakukingaku_sotogaku: this.iyakukin_baibaidaikin_wariai,
          iyakukingaku3_nyuryoku: this.iyakukin_sonohoka_kingaku
        }
        const bpmData = _.merge(this.bpmData, bpm)

        this.$store.dispatch(SAVE_JRB_M007_11, jrb).then(() => {
          this.$store.dispatch(SAVE_EDIT_MODE, {'jrb07_11': true})
          this.$store.dispatch(SAVE_BPM, bpmData)
          this.$store.dispatch(SAVE_KEIYAKU).then(() => {
            this.popupActiveSaveForm = false
            setTimeout(() => {
              this.$router.push({name: 'jusetsu-m006-01'})
            }, 200)
          })
        })
      }
      this.handleCheckCount(handle)
      this.popupActiveSaveForm = false
    },
    validateWarning() {
      let hasWarning = false
      const keys = Object.keys(this.formValidation)
      for (let i = 0; i < keys.length; i++) {
        const key = keys[i]
        if (!this.formValidation[key].patterns || !this.formValidation[key].patterns.length
          || this.formValidation[key].patterns.includes(this.jrb)) {
          if (typeof (this.formValidation[key].warning) === 'function' && this.formValidation[key].warning()) {
            this.formValidation[key].status = false
            hasWarning = true
            this.highlight(key)
          } else if (this.formValidation[key].warning === true && (this[key] === null || this[key] === undefined || this[key] === '')) {
            this.formValidation[key].status = false
            hasWarning = true
            this.highlight(key)
          } else{
            this.formValidation[key].status = true
            this.unhighlight(key)
          }
        }
      }
      this.checkValidate = true
      return hasWarning
    },
    highlight(key) {
      // radiobox
      $('.con-vs-radio').each((idx, el) => {
        if ($(el).find(`input[name='${key}']`).length) {
          $(el).find('span.vs-radio--borde').css({'border-color': '#eea840'})
        }
      })
      // checkbox
      $('.con-vs-checkbox').each((idx, el) => {
        if ($(el).find(`input[vs-name='${key}']`).length) {
          $(el).find('span.vs-checkbox').css({'border-color': '#eea840'})
        } else if ($(el).find(`input[name='${key}']`).length) {
          $(el).find('span.vs-checkbox').css({'border-color': '#eea840'})
        }
      })
      // vs-input
      $(`input[name='${key}']`).css({'background-color': 'rgb(255 197 54 / 60%)'})
    },
    unhighlight(key) {
      // radiobox
      $('.con-vs-radio').each((idx, el) => {
        if ($(el).find(`input[name='${key}']`).length) {
          $(el).find('span.vs-radio--borde').css({'border-color': 'rgb(200, 200, 200)'})
        }
      })
    },
    async checkSave() {
      const hasWarning = await this.validateWarning()
      if (hasWarning) {
        this.messageWhenHanei =  MESSAGE.M1017
      }else{
        this.messageWhenHanei =  MESSAGE.M1007
      }
      this.popupActiveSaveForm = true
    },
    lostFocus() {
      if (this.checkValidate === true) {
        setTimeout(() => { this.validateWarning() }, 100) 
      }
    },
    focusOut() {
      this.currentFocus = 0
      this.lostFocus()
    },
    getArrayHighlight(data) {
      const idElement = []
      const block_list = data.block_list
      block_list.forEach(item => {
        item.part_list.map(ele => {
          if(!ele.label_flg) {
            idElement.push(ele.id_element)
          }
        })
      })
      this.arrayHighlightId = idElement.filter(item => item.includes('jrb'))
    },
    handleGetCommentId() {
      let jrbPatternHighlight = []
      const code = +this.$store.getters.code
      switch (this.jrb) {
      case 'jrb-01':
        jrbPatternHighlight = M007_11_jrbHighlight
        this.index = 6
        break
      case 'jrb-02':
        jrbPatternHighlight = M007_11_jrbHighlight
        this.index = 63
        break
      case 'jrb-03':
        jrbPatternHighlight = M007_11_jrbHighlight
        this.index = 75
        break
      case 'jrb-04':
        jrbPatternHighlight = M007_11_jrbHighlight
        this.index = 75
        break
      default:
        break
      }
      const jrbHighlight = jrbPatternHighlight.map(item => {
        if(item) {
          this.index = this.index + 1
          if(this.jrb === 'jrb-01') {
            if(code === 21 || code === 22 || code === 23) {
              item = `${this.jrb}-05-${this.index}`
            } else if(code === 31 || code === 32 || code === 33) {
              item = `${this.jrb}-09-${this.index}`
            } else {
              item = `${this.jrb}-01-${this.index}`
            }
          } else {
            item = `${this.jrb}-${this.index}`
          }
        }
        return item
      })
      this.arrayCommentId = jrbHighlight
    },
    handleShowHightlightInPage(highlight) {
      const idHightlighted = this.arrayHighlightId
      this.handleShowHightlightInPageMixin(highlight, idHightlighted)
    }
  }
}
</script>


<style scoped>
.jrb {
  font-weight: bold;
}
.input {
  width: auto;
}

.sytle-button {
  display: flex;
  justify-content: flex-end;
  margin: 30px;
  gap: 30px;
}

table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
  border-radius: 0px;
}
td {
  font-size: 0.85rem;
  font-weight: 900;
}

.table-out {
  margin: 10px 0px;
  border: 2px solid rgb(201, 198, 198);
  border-radius: 5px;
  border-collapse: collapse;
}

.m-auto-top-bottom {
  margin: auto 0;
}

.col-title {
  color: white;
  background-color: #80808069;
  border-radius: 0px;
}

.con-exemple-prompt {
  padding: 10px;
  padding-bottom: 0px;
}

.itaku-dialog td {
  font-weight: 400;
}

.itaku-dialog th {
  text-align: center;
}

.mtb-10 {
  margin: 10px 0;
}
.btn-positive {
  border: 1px solid #7367F0;
}
.baikei-transition-enter-active {
  transition: all 0.25s ease-out;
}

.baikei-transition-leave-active {
  transition: all 0.25s ease-in;
}

.baikei-transition-enter,
.baikei-transition-leave-to {
  transform: translateX(-50px);
  opacity: 0;
  width: 0% !important;
}
.flex-grow-width-make {
  flex-grow: 1;
  flex-basis: 57%;
  min-width: 57%;
}
.preview-edit-screen {
  overflow: scroll;
  height: 620px;
  margin-top: 0.75rem;
}
.comment-frame {
  overflow: scroll;
  height: 620px;
  margin-top: 0.75rem;

}
.w-57 {
  width: 56%;
}
.w-65 {
  width: 65%;
}
</style>
